import React from 'react';
import TaxbillEditContainer from '../../containers/taxIssuedmng/TaxbillEditContainer';

const TaxIssuedEditPage = () => {
  return <TaxbillEditContainer />
};

export default TaxIssuedEditPage;
